export const skippedColor = '#8a8d90';
export const cancelledColor = '#6a6e73';
export const pendingColor = '#8bc1f7';
export const runningColor = '#06c';
export const successColor = '#38812f';
export const failureColor = '#c9190b';
